import { getLotteryRecord } from "@/api/luosikeHistory";
import { onMounted, reactive, toRefs } from "vue";

export default function () {
  const state = reactive({
    luosikeList: [],
  });

  // 获取螺蛳壳记录
  const getLuosikeList = async () => {
    const { rows } = await getLotteryRecord();
    state.luosikeList = rows;
  };

  onMounted(() => {
    getLuosikeList();
  });

  return {
    ...toRefs(state),
  };
}
